import { Routes, Route, Navigate } from "react-router-dom";
import {
  DashboardPage,
  PatientsPage,
  AddPatientsPage,
  DoctorsPage,
  AddDoctorsPage,
  CalendarPage,
  ProfilePage,
  ProcedureRoomsPage,
  ProcedureCalendarPage,
  ValuationCalendarPage,
  RegisterShiftPage,
  RegisterShiftProcedurePage,
  SummaryProcedurePage,
} from "../pages";

export const SecretaryRoute = () => {
  return (
    <>
      <Routes>
        <Route path="secretary/dashboard" element={<DashboardPage />} />
        <Route path="secretary/patients" element={<PatientsPage />} />
        <Route path="secretary/add-patient" element={<AddPatientsPage />} />
        <Route path="secretary/doctors" element={<DoctorsPage />} />
        <Route path="secretary/add-doctor" element={<AddDoctorsPage />} />
        <Route path="secretary/calendar" element={<CalendarPage />} />
        <Route path="secretary/profile" element={<ProfilePage />} />
        <Route
          path="secretary/surgery-rooms"
          element={<ProcedureRoomsPage />}
        />
        <Route
          path="secretary/procedure-calendar"
          element={<ProcedureCalendarPage />}
        />
        <Route
          path="secretary/valuation-calendar"
          element={<ValuationCalendarPage />}
        />
        <Route
          path="secretary/register-shift"
          element={<RegisterShiftPage />}
        />
        <Route
          path="secretary/register-shift-procedure"
          element={<RegisterShiftProcedurePage />}
        />
        <Route
          path="secretary/summary-procedures"
          element={<SummaryProcedurePage />}
        />
        <Route path="/*" element={<Navigate to={"secretary/dashboard"} />} />
      </Routes>
    </>
  );
};
